import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import BottomDrawer from "../../../../../components/WMS/Mobile/BottomDrawer";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";
import {ReactComponent as PrinterIcon} from 'assets/img/wms/printerIcon.svg'
import {ReactComponent as BookIcon} from 'assets/img/book.svg'

ShippingActionDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    openPrinterConfigurationDrawer: PropTypes.func.isRequired,
    openExpeditionListDrawer: PropTypes.func.isRequired
};

function ShippingActionDrawer({open, handleClose, openPrinterConfigurationDrawer, openExpeditionListDrawer}) {
    return (
        <BottomDrawer
            open={open}
            onClose={handleClose}
            openMaxHeight
            maxHeight={"50%"}
            title={<FormattedMessage id={"wms.shipping.actionDrawer.title"}/>}
        >
            <Grid container direction={"column"} sx={{padding: "8px"}}>
                <CustomButton
                    color={"default"}
                    variant={"nude"}
                    onClick={openPrinterConfigurationDrawer}
                    fullWidth
                    contentJustify={"left"}
                >
                    <PrinterIcon style={{marginRight: "8px", width: "18px", height: "18px"}} />
                    <FormattedMessage id={"wms.packing.action.printerConfigButton.title"}/>
                </CustomButton>

                <CustomButton
                    color={"default"}
                    variant={"nude"}
                    onClick={openExpeditionListDrawer}
                    fullWidth
                    contentJustify={"left"}
                >
                    <BookIcon style={{marginRight: "8px", width: "18px", height: "18px"}} />
                    <FormattedMessage id={"wms.shipping.show_expeditions_lists"}/>
                </CustomButton>
            </Grid>
        </BottomDrawer>
    );
}

export default ShippingActionDrawer;